var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeStaging(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19v-4a3 3 0 0 1 3-3h13a3 3 0 0 1 3 3v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19h16a3 3 0 0 1 3 3v4H4v-4a3 3 0 0 1 3-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26v2m14-2v2M20 12v7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7c-3 0-5-2-5-5m5 5c-3 0-5 2-5 5m5-5c3 0 5-2 5-5m-5 5c3 0 5 2 5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStaging);
export default __webpack_public_path__ + "static/media/home-staging.9859f9401941e5d687218c79cb77ca15.svg";
export { ForwardRef as ReactComponent };